var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { EGDSCard, EGDSCardContentSection } from '@egds/react-core/cards';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { inject, observer } from 'mobx-react';
import { ViewRow } from '@egds/react-search-experience';
import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { withLocalization } from '@shared-ui/localization-context';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { PropertySummaryHeader } from './property-summary-header';
import { SharedUiPropertySearchLinkWrapper } from 'components/infosite/shared-ui/offers/property-search-link-wrapper';
import { SharedUiSaveTripItemWrapper } from './shared-ui/details/save-trip-item-wrapper';
import { SharedUiShareActionsWrapper } from './shared-ui/details/share-actions-wrapper';
import { SharedUiShortlistWrapper } from './shared-ui/details/shortlist-wrapper';
import { SharedUiStickyPriceHeaderWrapper } from './shared-ui/offers/shared-ui-property-sticky-price-header-wrapper';
export let PropertySummaryBackLinkWrapper = class PropertySummaryBackLinkWrapper extends React.Component {
  render() {
    var _a, _b;
    const {
      currentHotel,
      multiItem,
      l10n
    } = this.props;
    const searchCriteria = currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.searchCriteria;
    const regionId = searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.regionId;
    const startDate = searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.startDate;
    const endDate = searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.endDate;
    const isDateLess = searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.isDateless;
    const isMultiItem = (_b = (_a = multiItem === null || multiItem === void 0 ? void 0 : multiItem.cartInfo) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : multiItem === null || multiItem === void 0 ? void 0 : multiItem.isPackageShoppingPath();
    const cardContent = (viewLarge = false) => React.createElement("div", null, React.createElement(EGDSLayoutFlex, {
      alignItems: "center",
      style: {
        minHeight: '3rem'
      }
    }, React.createElement(EGDSLayoutFlexItem, {
      grow: 1
    }, React.createElement("div", null, React.createElement(SharedUiPropertySearchLinkWrapper, null))), !isDateLess && viewLarge && !isMultiItem && React.createElement(Experiment, {
      name: "Price_Summary_above_the_scroll_line_on_PDP"
    }, React.createElement(ExperimentControl, null), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement(EGDSLayoutFlexItem, null, React.createElement(SharedUiStickyPriceHeaderWrapper, {
      hideCtaButton: true,
      wrapPriceSummary: true
    }))), React.createElement(ExperimentVariant, {
      bucket: 2
    }, React.createElement(EGDSLayoutFlexItem, null, React.createElement(SharedUiStickyPriceHeaderWrapper, {
      wrapPriceSummary: true
    })))), React.createElement(SharedUiShareActionsWrapper, null), React.createElement("div", {
      "data-stid": "favorite-save-button"
    }, React.createElement(SharedUiShortlistWrapper, null), React.createElement(SharedUiSaveTripItemWrapper, null))));
    return React.createElement(EGDSLayoutFlexItem, null, React.createElement(Viewport, null, React.createElement(ViewSmall, null, React.createElement(Experiment, {
      name: "mWeb_larger_image_for_top_of_PDP_gallery"
    }, React.createElement(ExperimentControl, null, React.createElement(React.Fragment, null, React.createElement(PropertySummaryHeader, {
      l10n: l10n,
      multiItem: multiItem,
      regionId: regionId,
      startDate: startDate,
      endDate: endDate
    }), React.createElement(EGDSCard, {
      className: "custom-css-flat-border-top custom-css-flat-border-bottom",
      overflow: true
    }, React.createElement(EGDSCardContentSection, {
      padded: false
    }, React.createElement(EGDSSpacing, {
      padding: {
        block: 'one',
        inline: 'two'
      }
    }, cardContent(false)))))), React.createElement(ExperimentVariant, {
      bucket: 1
    }, (multiItem === null || multiItem === void 0 ? void 0 : multiItem.isPackageShoppingPath()) && React.createElement(ViewRow, {
      layout: "fullwidth",
      paddedViewRow: false,
      canvasTheme: "primary"
    }, React.createElement(EGDSSpacing, {
      padding: {
        inline: 'two'
      }
    }, React.createElement("div", null, React.createElement(PropertySummaryHeader, {
      l10n: l10n,
      multiItem: multiItem,
      regionId: regionId,
      startDate: startDate,
      endDate: endDate
    }))))), React.createElement(ExperimentVariant, {
      bucket: 2
    }, (multiItem === null || multiItem === void 0 ? void 0 : multiItem.isPackageShoppingPath()) && React.createElement(ViewRow, {
      layout: "fullwidth",
      paddedViewRow: false,
      canvasTheme: "primary"
    }, React.createElement(EGDSSpacing, {
      padding: {
        inline: 'two'
      }
    }, React.createElement("div", null, React.createElement(PropertySummaryHeader, {
      l10n: l10n,
      multiItem: multiItem,
      regionId: regionId,
      startDate: startDate,
      endDate: endDate
    }))))))), React.createElement(ViewLarge, null, React.createElement(EGDSCard, {
      className: "custom-css-flat-border-top custom-css-flat-border-bottom",
      overflow: true
    }, React.createElement(EGDSCardContentSection, {
      padded: false
    }, React.createElement(PropertySummaryHeader, {
      l10n: l10n,
      multiItem: multiItem,
      regionId: regionId,
      startDate: startDate,
      endDate: endDate
    }), React.createElement(EGDSSpacing, {
      padding: {
        block: 'two',
        inline: 'two'
      }
    }, cardContent(true)))))));
  }
};
PropertySummaryBackLinkWrapper = __decorate([withLocalization, inject('currentHotel', 'multiItem'), observer], PropertySummaryBackLinkWrapper);